import { IS_PROD } from '@webapp/infrastructure/envs'
import { useRunConversationTurnPresenter } from './useRunConversationTurnPresenter'
import { ConversationStream } from '../../views/ConversationStream'
import { ConversationTelemetry } from '../../views/ConversationTelemetry'

export const RunConversationTurnPresenter = () => {
  const {
    data: { items, telemetry },
    states: { isStreaming, thinkingLabel },
    commands: { selectChoice, sendMessage, selectCatalogItem },
  } = useRunConversationTurnPresenter()

  return (
    <>
      <ConversationStream
        items={items}
        isStreaming={isStreaming}
        thinkingLabel={thinkingLabel}
        onChoiceSelect={selectChoice}
        onSendMessage={sendMessage}
        onCatalogItemSelect={selectCatalogItem}
      />
      {!IS_PROD && <ConversationTelemetry events={telemetry} />}
    </>
  )
}
